import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Modal, Button, Input } from 'semantic-ui-react';
import { Formik } from 'formik';
import { checkUser, hideAuth, getDetails } from '../store/actions/Auth';
import { auth } from '../firebase/index';


const AuthModal = () => {
   const dispatch = useDispatch();
   const visible = useSelector((state) => state.auth.visible);
   const [error, setError] = useState(null);
   const history = useHistory();

	return (
		<Modal open={visible} onClose={() => dispatch(hideAuth())} size="mini">
			<Modal.Header>Iniciar Sesión</Modal.Header>
			<Modal.Content>
				<Modal.Description>
					<p className="small quiet">
						Inicie la sesión con su correo electrónico y contraseña.
					</p>
					<Formik
						initialValues={{
							password: '',
							email: '',
						}}
						onSubmit={(values, actions) => {
							auth
								//.signInAnonymously()
								.signInWithEmailAndPassword(values.email, values.password)
								.then(async (authResponse) => {

									const userId = authResponse.user.uid;

									try {
										const response = await fetch('/firebase/token', {
											method: "POST",
											body: JSON.stringify({
												userId: userId
											}),
											headers: {
												'Content-Type': 'application/json; charset=utf-8',
												'x-api-key': process.env.REACT_APP_API_KEY
											}
										});
										if (!response.ok) {
											await auth.signOut();
											throw new Error("Error al iniciar sesión");
										}
									} 
									catch (error) {
										console.error(error);
										throw error;
									}

									actions.setSubmitting(false);
							   dispatch(checkUser(authResponse.user));
							   dispatch(getDetails(authResponse.user.uid));
							   dispatch(hideAuth());
							   setTimeout(() => window.location.replace('/app/archivo'), 0);
								})
								.catch((err) => {
									setError(err.message);
									actions.setSubmitting(false);
								});
						}}
					>
						{(props) => (
							<Form onSubmit={props.handleSubmit} noValidate>
								<Form.Field
									autoComplete="true"
									name="email"
									type="email"
									required
									label="Correo Electrónico"
									placeholder="juan@gmail.com"
									control={Input}
									onChange={props.handleChange}
									onBlur={props.handleBlur}
									value={props.values.email}
								/>
								<Form.Field
									autoComplete="true"
									name="password"
									type="password"
									required
									label="Contraseña"
									placeholder="contraseña..."
									control={Input}
									onChange={props.handleChange}
									onBlur={props.handleBlur}
									value={props.values.password}
								/>
								<Form.Button
									size="small"
									fluid
									loading={props.isSubmitting}
									type="submit"
								>
									Iniciar Sesión
								</Form.Button>
								{error && <p className="color-red small txt-center">{error}</p>}
							</Form>
						)}
					</Formik>
				</Modal.Description>
			</Modal.Content>
			<Modal.Actions>
				<Button
					size="tiny"
					content="Cerrar"
					onClick={() => {
						dispatch(hideAuth());
						setError(null);
					}}
				/>
			</Modal.Actions>
		</Modal>
	);
};

export default AuthModal;
